import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-store-stock",
  "use": "icon-soc-l1-store-stock-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-store-stock\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M192 192h640v128H192V192zm0 160h192v480H192V352zm224 0h192v480H416V352zm224 0h192v480H640V352z\" />\r\n  <path d=\"M240 416h96v48H240v-48zm224 0h96v48h-96v-48zm224 0h96v48h-96v-48z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-store-stock.svg
// module id = BrBS
// module chunks = 534